import React, { useEffect, useState } from 'react';

import SignIn from './SignIn';
// import Phone from './Phone';
// import OTP from './OTP';

import ThemePopover from 'layouts/AppLayout/Navbar/ThemePopover';
import LanguagePopover from 'layouts/AppLayout/Navbar/LanguagePopover';

import ResetPhone from './ResetPhone';
import ResetOTP from './ResetOTP';
import ResetPassword from './ResetPassword';
import Page from 'components/Page';
import {
  Avatar,
  styled,
  Box,
  Button,
  Fade,
  Stack,
  Typography,
  AppBar,
} from '@mui/material';

import { FormattedMessage } from 'react-intl';

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: 'transparent',
  marginTop: 4,
  // marginBottom: 8,
  // lineHeight: 1.2,
  display: 'flex',
  flexDirection: 'column',
  rowGap: 8,
  // fontWeight: 900,
  // letterSpacing: 1,
  textAlign: 'center',
  // fontSize: "6rem",
  // fontFamily: "Barlow, sans-serif",
  background:
    'linear-gradient(300deg, rgb(0, 167, 111) 0%, rgb(255, 171, 0) 25%, rgb(0, 167, 111) 50%, rgb(255, 171, 0) 75%, rgb(0, 167, 111) 100%) 0% 0% / 400% text',
  padding: 0,
  animation: 'ripple 40s infinite ease',
  '@keyframes ripple': {
    '0%': {
      backgroundPosition: '10% center',
    },
    '25%': {
      backgroundPosition: '100% center',
    },
    '50%': {
      backgroundPosition: '190% center',
    },
    '75%': {
      backgroundPosition: '100% center',
    },
    '100%': {
      backgroundPosition: '10% center',
    },
  },
}));

const UserPopup = () => {
  const [extra, setExtra] = React.useState(null);
  const [step, setStep] = React.useState(0);
  const [screenSaver, setScreenSaver] = React.useState(false);
  const startLiveBackground = () => {};

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };
    window.addEventListener('online', handleStatusChange);
    window.addEventListener('offline', handleStatusChange);
    return () => {
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, [isOnline]);

  const handleType = (data, extra = null) => {
    setExtra(extra);
    setStep(data);
  };

  const stepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return <SignIn handleType={handleType} startLiveBackground={startLiveBackground} />;
      case 3:
        return <ResetPhone handleType={handleType} />;
      case 4:
        return <ResetOTP handleType={handleType} extra={extra} />;
      case 5:
        return <ResetPassword handleType={handleType} extra={extra} />;
      default:
        return 'ناشناخته';
    }
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     !screenSaver && setScreenSaver((prev) => !prev);
  //   }, 10000);
  //   return () => clearTimeout(timer);
  // }, [screenSaver, transform]);

  return (
    <Page title="ورود">
      <AppBar
        elevation={0}
        sx={{
          m: 1,
          borderRadius: 2,
          bgcolor: 'background.default',
        }}
      >
        {!isOnline && (
          <Typography
            mx={1}
            px={1}
            fontWeight="bold"
            textAlign="center"
            color="error.main"
            bgcolor="warning.light"
            borderRadius="0 0 16px 16px"
          >
            لطفا دسترسی اینترنت خود را بررسی کنید!
          </Typography>
        )}
        <Stack direction="row" alignItems="center" px={1} minHeight={64}>
          <Box sx={{ flexGrow: 1 }} />

          <Stack columnGap={1} direction="row" alignItems="center">
            {/* <IconButton color="warning" onClick={openTour}>
            <HelpOutlineRoundedIcon fontSize="small" />
          </IconButton> */}
            <ThemePopover />
            <LanguagePopover />
          </Stack>
        </Stack>
      </AppBar>
      <Stack
        position="relative"
        overflow="hidden"
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <Stack width="100vw" height="100vh">
          <Fade in={!screenSaver} timeout={1000}>
            <Stack height="100%" width="100%" justifyContent="center" alignItems="center" px={2} pt={10} pb={4}>
              <Stack
                width="100%"
                maxWidth={520}
                justifyContent="center"
                alignItems="center"
                sx={{ transform: { xs: 'translateY(-24px)', sm: 'translateY(-40px)' } }}
              >
                <Stack alignItems="center" sx={{ m: 2 }}>
                  <Box
                    component="img"
                    src="/assets/logo_satrap.png"
                    alt="Satrap"
                    sx={{
                      width: { xs: 120, sm: 152 },
                      height: { xs: 120, sm: 152 },
                      mb: 2,
                      objectFit: 'contain',
                    }}
                  />
                  <Stack alignItems="center">
                    <StyledTitle fontSize={{ xs: '3rem', sm: '4rem' }} fontWeight="bold">
                      <FormattedMessage id="brand" />
                    </StyledTitle>
                    <StyledTitle variant="h5">
                      <FormattedMessage id="brand_title" />
                    </StyledTitle>
                  </Stack>
                </Stack>
                {stepContent(step)}
              </Stack>
            </Stack>
          </Fade>
          <Fade in={screenSaver} timeout={1000}>
            <Stack height="100%" justifyContent="center" alignItems="center" position="absolute" top={0} rowGap={2}>
              <Avatar sx={{ width: 120, height: 120 }} variant="circular" alt="user" src="/assets/images/avatar.jpg" />
              <Button
                fullWidth
                color="inherit"
                variant="outlined"
                sx={{ color: '#fff' }}
                onClick={() => setScreenSaver(!screenSaver)}
              >
                ورود
              </Button>
            </Stack>
          </Fade>
        </Stack>
      </Stack>
    </Page>
  );
};

export default UserPopup;
